module.exports = __webpack_public_path__ + "portal-static/img/bg.f4f49317.png";